export const LERNFELD_PERMISSIONS = {
  read: 'Lernfeld.Read',
  write: 'Lernfeld.Write',
} as const;
